import { Skeleton } from "ui";

export function SandboxSkeleton() {
  return (
    <>
      {/* Config column */}
      <div className="rounded-lg border border-foundations-subtle bg-foundations-default p-4 lg:w-0 lg:flex-[2]">
        <div className="space-y-6">
          {/* Action row */}
          <div className="flex gap-4">
            <Skeleton className="h-10 flex-1 rounded-md" />
            <Skeleton className="h-10 flex-1 rounded-md" />
            <Skeleton className="h-10 w-10 rounded-md" />
          </div>

          {/* Setup sections */}
          {Array.from({ length: 2 }).map((_, section) => (
            <div key={section} className="space-y-4">
              <div className="flex items-center gap-3">
                <Skeleton className="h-px flex-1" />
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-px flex-1" />
              </div>

              {Array.from({ length: 2 }).map((_, field) => (
                <div key={field} className="flex flex-col gap-1.5">
                  <Skeleton className="h-3 w-28" />
                  <Skeleton className="h-10 w-full rounded-md" />
                </div>
              ))}
            </div>
          ))}

          {/* Code editor */}
          <Skeleton className="h-72 w-full rounded-md" />
        </div>
      </div>

      {/* Preview column */}
      <div className="flex h-[900px] flex-col lg:h-auto lg:flex-[3]">
        {/* Tab bar */}
        <div className="flex items-center justify-between border-b border-b-foundations-subtle pb-2.5">
          <div className="flex gap-4">
            <Skeleton className="h-5 w-20" />
            <Skeleton className="h-5 w-28" />
          </div>
          <div className="flex items-center gap-4">
            <Skeleton className="h-10 w-10 rounded-md" />
            <Skeleton className="h-10 w-28 rounded-md" />
          </div>
        </div>

        {/* Preview panel */}
        <Skeleton className="mt-4 min-h-[400px] flex-1 rounded-md" />
      </div>
    </>
  );
}
